import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcDomains = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M15.43 14a28.271 28.271 0 0 0 0-4H8.57a28.265 28.265 0 0 0 0 4h6.86Zm-.221 2H8.79c.54 3.532 1.774 6 3.209 6s2.669-2.468 3.209-6ZM12 2c-1.435 0-2.669 2.468-3.209 6h6.418c-.54-3.532-1.774-6-3.209-6Z",
  fill: "var(--mds-nav-icon-accent)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M6.565 14a30.349 30.349 0 0 1 0-4H2.2a10.045 10.045 0 0 0 0 4h4.365Zm-3.733 2H6.77c.194 1.38.488 2.647.867 3.732.191.545.414 1.076.675 1.566A10.035 10.035 0 0 1 2.832 16Zm14.398 0h3.938a10.035 10.035 0 0 1-5.48 5.298c.26-.49.484-1.02.675-1.566.38-1.085.673-2.352.867-3.732Zm4.57-2h-4.365a30.383 30.383 0 0 0 0-4H21.8a10.05 10.05 0 0 1 0 4Zm-4.57-6h3.938a10.034 10.034 0 0 0-5.48-5.298c.26.49.484 1.021.675 1.567.38 1.085.673 2.351.867 3.731ZM7.637 4.269C7.257 5.354 6.964 6.62 6.77 8H2.832a10.034 10.034 0 0 1 5.48-5.298 11.36 11.36 0 0 0-.675 1.567Z",
  fill: "var(--mds-nav-icon-medium)"
})), "IcDomains");

export { IcDomains };
//# sourceMappingURL=ic-domains.js.map
